module.exports = __webpack_public_path__ + "img/weixun.ce1df30b.png";